import React, { useState } from "react";
import assets from "../../../../../assets/assets";
import styled from "styled-components";
import axios from "axios";
import { useAxiosConfigGlobal } from "../../../../../components/Config/axios";
import { useEffect } from "react";
import { distributionUrl } from "../../../../Config/url";
import {
  mobileBottomSheet,
  mobileOverlay,
} from "../../../../Scripts/mobileBottomSheet";
import {
  IconController,
  ImgController,
  LottieController,
} from "../../../../Scripts/ImgController";
import Skeleton from "react-loading-skeleton";
import Ripples from "react-ripples";
const Wrapper = styled.div`
  select {
    border: 1px solid #d1d5db;
    padding: 8px;
    border-radius: 8px;
  }
  input {
    border: 1px solid #d1d5db;
    padding: 8px;
    border-radius: 8px;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 12px;
  }
  .bank-selection {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    margin: auto;
    padding: 8px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 8px;
  }
  input[type="number"] {
    appearance: textfield;
    -moz-appearance: textfield;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 8px;
    font-size: 12px;
    font-weight: 600;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
const PopupStyled = styled.div`
  position: absolute;
  bottom: 0;
  top: 140px;
  z-index: 103 !important;
  .modal {
    max-width: 220px;
    height: 200px;
    background: #ffffff;
    border: 1px solid #f3f4f6;
    box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1),
      0px 10px 10px -5px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    padding: 16px 12px;
    overflow-y: scroll;
  }
  .modal::-webkit-scrollbar {
    width: 0 !important;
    display: none !important;
  }
  ${mobileBottomSheet(".modal")}
  @media (max-width: 767px) {
    .modal {
      height: auto;
      max-height: 60vh;
      padding: 16px;
    }
  }
`;
const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 102 !important;
  top: 0;
  left: 0;
  ${mobileOverlay}
`;
const AccountSection = ({
  setCKPopup,
  setCKPopupType,
  setCKPopupMessage,
  isUserCanEdit,
  oneRingRulesAll,
}) => {
  const axiosConfig = useAxiosConfigGlobal();
  const [editable, setEditable] = useState(false);
  const [bankChoose, setBankChoose] = useState(false);
  const [account, setAccount] = useState();
  const [banks, setBanks] = useState([]);
  const [selectedBankName, setSelectedBankName] = useState("");
  const [selectedBankId, setSelectedBankId] = useState(Number);
  const [nameInput, setNameInput] = useState("");
  const [numberInput, setNumberInput] = useState(Number);
  const [requestSent, setRequestSent] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const fetchBanks = () => {
    axios
      .get(distributionUrl + "panel-api/oauth/banks", axiosConfig)
      .then((res) => {
        setBanks(res.data.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          oneRingRulesAll("logout");
        }
      });
  };
  const fetchAccounts = () => {
    axios
      .get(distributionUrl + "panel-api/oauth/agreement:accounts", axiosConfig)
      .then((res) => {
        setAccount(res.data.data);
        setLoaded(true);
        if (selectedBankName.length === 0) {
          setSelectedBankId(res.data.data.bank.id);
          setSelectedBankName(res.data.data.bank.name);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          oneRingRulesAll("logout");
        }
      });
  };
  const changeBankHandler = () => {
    if (
      selectedBankId !== null &&
      nameInput.length !== 0 &&
      numberInput.length >= 8
    ) {
      setRequestSent(true);
      const data = {
        bank_id: selectedBankId,
        name: nameInput,
        number: numberInput,
        currency: "MNT",
      };
      axios
        .put(
          distributionUrl + "panel-api/oauth/agreement:accounts/" + account?.id,
          data,
          axiosConfig
        )
        .then((res) => {
          if (res.status === 200) {
            setAccount(res.data.data);
            setCKPopupType("Success");
            setCKPopupMessage("accountNumberChanged");
            setCKPopup(true);
            setEditable(false);
            setNameInput("");
            setNumberInput("");
            setRequestSent(false);
          }
        })
        .catch((err) => {
          if (err.response.status === 401) {
            oneRingRulesAll("logout");
          }
          setCKPopupType("Warning");
          setCKPopupMessage("somethingWrong");
          setCKPopup(true);
          setRequestSent(false);
        });
    } else {
      setCKPopupType("Info");
      setCKPopupMessage("fillTheFields");
      setCKPopup(true);
    }
  };

  useEffect(() => {
    fetchAccounts();
    fetchBanks();
  }, []);
  const banksMap = banks?.map((bank) => {
    const selectBankHandler = (bank) => {
      setSelectedBankName(bank.name);
      setSelectedBankId(bank.id);
    };
    return (
      <Ripples
        color="#0061ff40"
        during={600}
        className="rounded-lg"
        key={bank.id}
      >
        <div
          className="p-1 flex items-center cursor-pointer"
          onClick={() => {
            selectBankHandler(bank);
            setBankChoose(false);
          }}
        >
          <div className="w-7 h-7">
            <ImgController src={bank?.cover} className="w-6 h-6" />
          </div>
          <h5 className="font-semibold text-xs pl-1">{bank?.name}</h5>
        </div>
      </Ripples>
    );
  });
  return (
    <Wrapper className="border-CK ">
      <h5 className="font-bold text-sm pb-9">Дансны мэдээлэл</h5>
      {editable ? (
        <>
          {requestSent ? (
            <div
              className="absolute top-0 left-0 w-full h-full  rounded-xl"
              style={{ background: "#a9b7d280" }}
            >
              <div className="w-full h-full flex flex-row justify-center items-center">
                <LottieController
                  src={assets.lottie.loadingLottie}
                  className="w-32 h-32 flex flex-row justify-center"
                />
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="flex flex-row flex-wrap">
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">
                Бүртгэлтэй банк
              </h5>
              <div className="flex flex-row justify-between">
                <Ripples color="#0061ff40" during={600} className="rounded-lg">
                  <div
                    className="bank-selection"
                    onClick={() => {
                      setBankChoose(true);
                    }}
                  >
                    <h5 className="font-semibold text-xs">
                      {selectedBankName}
                    </h5>
                    <IconController
                      src={assets.svg.chevronDownBlue}
                      className="w-4 h-4"
                    />
                  </div>
                  <div className="flex-1"></div>
                </Ripples>
              </div>
              {bankChoose ? (
                <>
                  <Overlay
                    onClick={() => {
                      setBankChoose(false);
                    }}
                  ></Overlay>
                  <PopupStyled>
                    <div className="modal">
                      <div className="flex flex-col gap-2">{banksMap}</div>
                    </div>
                  </PopupStyled>
                </>
              ) : (
                ""
              )}
            </div>
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">
                Данс эзэмшигчийн нэр
              </h5>
              <input
                type="text"
                placeholder={account?.name}
                onChange={(value) => {
                  setNameInput(value.target.value);
                }}
              />
            </div>
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">
                Дансны дугаар
              </h5>
              <input
                type="number"
                placeholder={account?.number}
                onChange={(value) => {
                  setNumberInput(value.target.value);
                }}
              />
            </div>
          </div>
          <div className="flex flex-row justify-center items-center gap-2">
            <div className="cancel-button">
              <Ripples color="#0061FF40" during={600} className="rounded-2xl">
                <div
                  className="flex flex-row justify-center items-center px-3"
                  onClick={() => {
                    setEditable(false);
                  }}
                >
                  <h5 className="text-xs font-medium py-2 pr-1">Болих</h5>
                  <IconController
                    src={assets.svg.cancelIcon}
                    className="h-4 w-4"
                  />
                </div>
              </Ripples>
            </div>
            <div className="confirm-button">
              <Ripples color="#ffffff40" during={600} className="rounded-2xl">
                <div
                  className="flex flex-row justify-center items-center px-3"
                  onClick={() => {
                    changeBankHandler();
                  }}
                >
                  <h5 className="text-xs font-medium py-2 pr-1">
                    Дансны мэдээлэл солих
                  </h5>
                  <IconController
                    src={assets.svg.saveIcon}
                    className="h-4 w-4"
                  />
                </div>
              </Ripples>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="flex flex-row flex-wrap">
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">
                Бүртгэлтэй банк
              </h5>
              {loaded ? (
                <h5 className="font-semibold text-xs">{account?.bank?.name}</h5>
              ) : (
                <div className="w-full h-full  ">
                  <Skeleton count={1} width="50%" />
                </div>
              )}
            </div>
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">
                Данс эзэмшигчийн нэр
              </h5>
              {loaded ? (
                <h5 className="font-semibold text-xs">{account?.name}</h5>
              ) : (
                <div className="w-full h-full  ">
                  <Skeleton count={1} width="50%" />
                </div>
              )}
            </div>
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">
                Дансны дугаар
              </h5>
              {loaded ? (
                <h5 className="font-semibold text-xs">{account?.number}</h5>
              ) : (
                <div className="w-full h-full  ">
                  <Skeleton count={1} width="50%" />
                </div>
              )}
            </div>
          </div>
          {isUserCanEdit ? (
            <div className="edit-button">
              <Ripples color="#0061ff40" during={600} className="rounded-lg">
                <div
                  className="flex flex-row justify-center items-center px-3"
                  onClick={() => {
                    setEditable(true);
                  }}
                >
                  <h5 className="text-xs font-medium py-2 pr-1">
                    Бүртгэлтэй данс солих
                  </h5>
                  <IconController
                    src={assets.svg.editIcon}
                    className="h-4 w-4"
                  />
                </div>
              </Ripples>
            </div>
          ) : (
            ""
          )}
        </>
      )}
    </Wrapper>
  );
};

export default AccountSection;
